module.exports = __webpack_public_path__ + "static/media/iconDelete.8d305723.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Iconos/iconDelete.svg
// module id = 2313
// module chunks = 0